// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"201":"media","594":"about","854":"menu","996":"franchise"}[chunkId] || chunkId) + "." + {"88":"9b821402","201":"3a0faddb","594":"2194257f","854":"796d0a4e","892":"958183df","996":"98b83907"}[chunkId] + ".css";
};